













    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import { Utils } from '@/helper/utils';
    import { Base } from './base';
    import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
    import {mask} from 'vue-the-mask';

    @Component({
               directives: {
                mask,
            },
            computed: {
                 computedDate: {
                    get() {
                    if (this.date) {
                        this.$emit('setDateValue', this.date);
                        return _dateTime.formatDate(this.date);
                    }
                    },
                    set(val) {
                        // empty block
                    },
                 },
            },
            props: [
                'label',
                'name',
                'date',
                'isResetFilter',
                'isDateFieldEditable',
                'showReset',
            ],
        })
        export default class CalendarComponent extends Base {
             public showDatePicker: boolean = false;
             public date: any = '';
             public validateRule: boolean = true;

            public mounted() {
                
                if (this.$props.date) {
                    this.date = this.$props.date;
                }
                
              }

              public resetDateFilter(): void {
                this.date = null; 
                this.$emit('setDateValue'); 
                this.showDatePicker = false;       
}
        }
